module.exports = __webpack_public_path__ + "img/Large-Horizontal-Rectangular-Attachment-11.53bbef9b.png";